export default "__VITE_ASSET__7281f27a__"